"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _commonCta = require("@mmc/common-cta");
var _themeProvider = require("@mmc/theme-provider");
var _clsx = _interopRequireDefault(require("clsx"));
var _calculationForm = require("./calculation-form.prop-types");
var _calculationForm2 = _interopRequireDefault(require("./calculation-form.css"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var costBreakdownIdCounter = 0;
var ExtraLinks = function ExtraLinks(_ref) {
  var data = _ref.data,
    onShareDialogClick = _ref.onShareDialogClick,
    onCostsOrTaxesModalClick = _ref.onCostsOrTaxesModalClick,
    calculation = _ref.calculation,
    market = _ref.market,
    labels = _ref.labels;
  var theme = (0, _themeProvider.useTheme)();
  var commonCtaClasses = (0, _clsx["default"])(_calculationForm2["default"].ctaBtn, _calculationForm2["default"].ctaBtnMdBlock);
  var _useState = (0, _react.useState)(0),
    idCount = _useState[0],
    setIdCount = _useState[1];
  if (!calculation.reqAQuoteFormUrl && calculation.requestQuoteRedirectUrl) {
    calculation.reqAQuoteFormUrl = calculation.requestQuoteRedirectUrl;
  }
  (0, _react.useEffect)(function () {
    setIdCount(costBreakdownIdCounter);
    costBreakdownIdCounter += 1;
  }, []);
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, (data.requestQuoteLabel || data.requestTestDrive) && /*#__PURE__*/_react["default"].createElement("div", {
    className: _calculationForm2["default"].extraLinksContainer
  }, data.requestQuoteLabel && calculation.reqAQuoteFormUrl && /*#__PURE__*/_react["default"].createElement(_commonCta.CommonCta, {
    "data-testid": "request-a-quote",
    theme: theme,
    classes: [_calculationForm2["default"].ctaBtn, _calculationForm2["default"].ctaBtnMdBlock],
    data: {
      label: data.requestQuoteLabel,
      priority: 'critical',
      url: calculation.reqAQuoteFormUrl
    }
  }), data.requestTestDrive && /*#__PURE__*/_react["default"].createElement(_commonCta.CommonCta, {
    "data-testid": "request-test-drive",
    theme: theme,
    classes: commonCtaClasses,
    data: _objectSpread(_objectSpread({}, data.requestTestDrive), {}, {
      priority: 'lowIcon',
      icon: 'SteeringWheel'
    })
  })), data.shareCalculationLabel && market !== 'ca' && /*#__PURE__*/_react["default"].createElement(_commonCta.CommonCta, {
    "data-testid": "share-calculation",
    theme: theme,
    classes: commonCtaClasses,
    data: {
      label: data.shareCalculationLabel,
      priority: 'lowIcon',
      icon: 'Upload'
    },
    clickEvent: onShareDialogClick
  }), market === 'ca' && /*#__PURE__*/_react["default"].createElement(_commonCta.CommonCta, {
    "data-testid": "cost-breakdown",
    theme: theme,
    classes: commonCtaClasses,
    data: {
      label: labels.costBreakDownBtnLabel,
      icon: 'Calculator',
      priority: 'lowIcon',
      ctaProps: {
        id: "cost-breakdown-" + idCount
      }
    },
    clickEvent: onCostsOrTaxesModalClick
  }), data.seeAllOffersLabel && calculation.viewSpecialOffersLink && /*#__PURE__*/_react["default"].createElement(_commonCta.CommonCta, {
    "data-testid": "offers",
    theme: theme,
    classes: commonCtaClasses,
    data: {
      label: data.seeAllOffersLabel,
      priority: 'lowIcon',
      icon: 'AnnualReport',
      url: calculation.viewSpecialOffersLink
    }
  }), data.buildAndPriceLabel && market === 'ca' && /*#__PURE__*/_react["default"].createElement(_commonCta.CommonCta, {
    "data-testid": "build-and-price",
    theme: theme,
    classes: commonCtaClasses,
    data: {
      label: data.buildAndPriceLabel,
      priority: 'critical',
      icon: 'AnnualReport',
      url: calculation.buildAndPriceUrl
    }
  }));
};
var _default = exports["default"] = /*#__PURE__*/_react["default"].memo(ExtraLinks);